import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { RegisterUser } from '../../../core/models/user';
import { CommonService } from '../../../core/services/v2/common.service';
import { UserService } from '../../../core/services/v2/user.service';
import { UtilsService } from '../../../core/services/v2/utils.service';
import { WindowLoaderService } from '../window-loader/window-loader.service';

@Component({
  selector: 'app-user-add-dialog',
  templateUrl: './user-add-dialog.component.html',
  styleUrls: ['./user-add-dialog.component.scss']
})
export class UserAddDialogComponent implements OnInit {
  roles: any;
  registerForm: FormGroup = this.fb.group({
    firstName: ['', Validators.required],
    lastName: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    role: ['', Validators.required]
  });
  constructor(
    public dialogRef: MatDialogRef<UserAddDialogComponent>,
    private loaderService: WindowLoaderService,
    private fb: FormBuilder,
    private userService: UserService,
    private commonService: CommonService,
    private _utils: UtilsService
  ) { }

  ngOnInit() {
    this.getRoles();
  }

  get f() {
    return this.registerForm.controls;
  }

  getRoles() {
    this.commonService.getUserRoles().subscribe(
      (res) => {
        this.roles = res.userRoles;
      },
      (error) => { console.error(error); }
    );
  }

  registerUser() {
    if (!this.registerForm.valid) {
      return;
    }
    const data = this.registerForm.getRawValue();
    const registerObj: RegisterUser = {
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      role: data.role,
    };
    this.loaderService.blockWithLoader(this.userService.addUser(registerObj)).subscribe(
      (res) => {
        if (res.resultStatus.isSuccess) {
          this._utils.showMessageSnackBar(`User '${registerObj.firstName} ${registerObj.lastName}' Added successfully.`);
          this.dialogRef.close();
        }
      },
      (error) => { console.error(error); this.loaderService.hide(); }
    );
  }

}
